// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"l3-z"};